<template>
    <div class="border flex w-24 justify-between px-2 gap-1.5 h-[33px] rounded-md items-center bg-white border-sn-blue">
        <span
            class="cursor-pointer text-xs p-1 flex"
            @click="updateQuantity(-1)"
        >
            <i class="fal fa-minus"></i>
        </span>

        <input
            :class="{'allow-input': allowInput}"
            class="bg-transparent text-center appearance-none w-full"
            placeholder="1"
            type="number"
            name="qty"
            v-model="internalQty"
            :min="min"
            :max="max"
            maxlength="4"
            @keyup="changeQuantity" />

        <span @click="updateQuantity(1)"
            class="cursor-pointer text-xs p-1 flex"
        >
            <i class="fal fa-plus"></i>
        </span>
    </div>
</template>

<style scoped>
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        @apply appearance-none;
    }
</style>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    quantity: { type: Number, default: 1 },
    allowInput: { type: Boolean, default: false },
    max: { type: Number, default: null },
    min: { type: Number, default: 1 },
    activeTheme: { type: Object, default: () => ({}) }
});

const emit = defineEmits(['updateQuantity']);

function updateQuantity(amount: number) {
    if (props.min !== null && amount < 0 && ((props.quantity + amount) < props.min)) {
        return false;
    }
    if (props.max !== null && amount > 0 && ((props.quantity + amount) > props.max)) {
        return false;
    }
    emit('updateQuantity', (props.quantity + amount));
}

function changeQuantity(e) {
    if (e.target.value.length >= 3) {
        if (e.keyCode >= 48 && e.keyCode <= 90) {
            e.preventDefault();
        }
    }
    if (props.min !== null && (e.target.value < props.min)) {
        internalQty.value = props.min as any;
    }
    if (props.max !== null && (e.target.value > props.max)) {
        internalQty.value = props.max as any;
    }
}

watch(() => props.quantity, () => {
    internalQty.value = props.quantity
});

const internalQty = computed({
    get() { return props.quantity; },
    set(v) { emit('updateQuantity', parseInt(v as any)); }
});

const getBorderColor = computed(() => {
    if (props.activeTheme !== null) {
        return props.activeTheme.theme_accent_color;
    }
    return '';
});
</script>
